import dayjs from "dayjs";
import React, { useState } from "react";
import { addOrUpdateBooking } from "../../../../../../APIs/Booking/UpdateBooking";
import { useDiaryContext } from "../../../../../../hooks/useDiaryContext";
import { EDSButton } from "../../../../../eds/EDSButton";
import { updateBooking } from "../SelectedBookingManageController";

const RunningLate = () => {
  const diaryContext = useDiaryContext();
  const { selectedBooking, bookings, setDiaryContext } = diaryContext;
  const [disabled, setDisabled] = useState<{ ref: number; value: boolean }>({
    ref: 0,
    value: false
  });

  const addMinsToBooking = (mins: number) => {
    if (!selectedBooking || !bookings) {
      return;
    }
    setDisabled({ ref: mins, value: true });

    const updatedDate = dayjs()
      .hour(parseInt(selectedBooking.time?.toString().split(":")?.[0] ?? ""))
      .minute(parseInt(selectedBooking.time?.toString().split(":")?.[1] ?? ""))
      .add(mins, "minute")
      .format("H:mm");

    const { updatedBookings, updatedBooking } = updateBooking({
      selectedBooking,
      bookings,
      bookingPropsToSave: {
        time: updatedDate
      }
    });

    setDiaryContext({ bookings: updatedBookings });
    addOrUpdateBooking({
      booking: updatedBooking,
      diaryContext
    });

    setTimeout(() => {
      // user feedback to stop multiple clicks
      setDisabled({ ref: mins, value: false });
    }, 600);
  };

  return (
    <div className="RunningLate pt-[var(--panelPadding)]">
      <div className="RunningLate-Title pt-[var(--panelPadding)] font-bold text-[length:var(--fontSize-base)]">
        Running late
      </div>
      <div className="RunningLate-Container mt-[var(--panelPadding)] flex flex-wrap">
        {[5, 10, 15].map((minAdjust) => (
          <EDSButton
            variant="secondary"
            size="md"
            key={`min-${minAdjust}`}
            className="RunningLate-Button w-[130px] shrink-0 mr-3 last:mr-0"
            disabled={disabled.ref === minAdjust ? disabled.value : false}
            onClick={() => {
              addMinsToBooking(minAdjust);
            }}
          >
            +{minAdjust} mins
          </EDSButton>
        ))}
      </div>
    </div>
  );
};

export default RunningLate;
